// ChatListCallsHub.jsx
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { formatChatPreview } from '../containers/ChatPage/formatChatPreview';
import { setActiveChatIdLocal } from '../actions/chatActions';
import Loader from '../components/Loader';

const getId = (value) => String(value?._id || value || '');

const getUserTitle = (user) => {
    if (!user || typeof user !== 'object') return '';

    const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();

    return name || user.email || user.username || '';
};

const getChatTitle = (chat, users, me) => {
    if (!chat) return 'Чат';

    if (chat.title) return chat.title;
    if (chat.entity?.title) return chat.entity.title;
    if (chat.user) return getUserTitle(chat.user) || `Чат #${String(chat._id).slice(-5)}`;

    const participants = Array.isArray(chat.participants) ? chat.participants : [];

    if (chat.isGroup || participants.length > 2) {
        return chat.title || `Комната #${String(chat._id).slice(-5)}`;
    }

    const peer = participants.find((item) => getId(item) !== getId(me?._id));
    const peerObject = typeof peer === 'object'
        ? peer
        : users.find((user) => getId(user._id) === getId(peer));

    return getUserTitle(peerObject) || `DM #${String(chat._id).slice(-5)}`;
};

const getUpdatedTime = (chat) => {
    return new Date(chat?.lastMessage?.createdAt || chat?.lastMessageAt || chat?.updatedAt || chat?.createdAt || 0).getTime();
};

const ChatListCallsHub = ({
    chats,
    users,
    me,
    activeChatId,
    loading,
}) => {
    const dispatch = useDispatch();

    const sortedChats = useMemo(() => {
        const arr = [...(chats || [])];

        arr.sort((a, b) => getUpdatedTime(b) - getUpdatedTime(a));

        return arr;
    }, [chats]);

    if (loading) {
        return (
            <div className="callsHub__list callsHub__sideList" style={{ height: '100%', minHeight: 0, overflow: 'auto' }}>
                <div className="callsHub__empty" style={{ display: 'grid', placeItems: 'center', padding: 20 }}>
                    <Loader typeSize="50px" />
                </div>
            </div>
        );
    }

    if (!sortedChats.length) {
        return (
            <div className="callsHub__list callsHub__sideList" style={{ height: '100%', minHeight: 0, overflow: 'auto' }}>
                <div className="callsHub__empty">Нет доступных чатов</div>
            </div>
        );
    }

    return (
        <div className="callsHub__list callsHub__sideList" style={{ height: '100%', minHeight: 0, overflow: 'auto' }}>
            {sortedChats.map((chat) => {
                const unread = Number(chat.unreadCount || 0) > 0;
                const missed = Number(chat.missedCount || 0) > 0;
                const title = getChatTitle(chat, users, me);
                const preview = formatChatPreview(chat.lastMessage, me?._id).slice(0, 80);
                const active = getId(chat._id) === getId(activeChatId);

                return (
                    <button
                        type="button"
                        key={chat._id}
                        className={`callsHub__row ${active ? 'is-active' : ''}`}
                        onClick={() => dispatch(setActiveChatIdLocal(chat._id))}
                    >
                        <div className="callsHub__rowAvatar">{title.slice(0, 1).toUpperCase()}</div>

                        <div className="callsHub__rowMain">
                            <div className="callsHub__rowTitle">
                                {title}

                                {unread && (
                                    <span className="callsHub__badge" style={{ marginLeft: 6 }}>
                                        {chat.unreadCount}
                                    </span>
                                )}

                                {missed && (
                                    <span className="callsHub__badge callsHub__badge--missed" style={{ marginLeft: 6 }}>
                                        Пропущ.: {chat.missedCount}
                                    </span>
                                )}
                            </div>

                            <div className="callsHub__rowSub">
                                {preview || (chat.updatedAt || chat.createdAt ? new Date(chat.updatedAt || chat.createdAt).toLocaleString() : '')}
                            </div>
                        </div>

                        {unread && <span className="callsHub__rowMeta">{chat.unreadCount}</span>}
                    </button>
                );
            })}
        </div>
    );
};

export default ChatListCallsHub;